import { RouteComponent } from "../../../../apps/idl/src/model";
import { DynamicPageComponent } from "./dynamicPage/dynamicPage.component";

/** Liste de tous les composants d'OSApp */
export const RouteComponentRegistries: RouteComponent[] = [
	{ id: 'dynamicPage', componentType: DynamicPageComponent },
];
